module.exports = __webpack_public_path__ + "static/media/BmindHolidays_cover.7eae1ecd.png";